module.exports = __webpack_public_path__ + "img/DSC_0755.e08933dc.jpeg";